module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_iter-step.js
// module id = 1098
// module chunks = 1